import { XIcon } from '@ghq-abi/design-system-icons';
import { Button } from '@ghq-abi/design-system-v2';
import { useTranslate } from '@tolgee/react';

import { ETolgeeDefault } from '~/shared/enums/ETolgeeDefault';
import { ETolgeeNamespaces } from '~/shared/enums/ETolgeeNamespaces';

export function ClearFilters({ onClick }: { onClick: () => void }) {
  const { t } = useTranslate(ETolgeeNamespaces.DEFAULT);

  return (
    <Button
      size="md"
      variant="secondary"
      onClick={onClick}
      className="flex items-center gap-2 border">
      <XIcon className="w-4 h-4 mr-2" />
      <div className="text-sm">
        {t(ETolgeeDefault.COMMON_ACTION_CLEAR_FILTERS)}
      </div>
    </Button>
  );
}
